import React from 'react'
import './curriculum.css'
import { Link } from "react-router-dom";
import Wave from '../wave/Wave'
import toddlers from '../../assets/baby_1.jpg'
import twos from '../../assets/girl_3.jpg'
import threes from '../../assets/boy_3.jpg'
import vpk from '../../assets/girl_4.jpg'

const PROGRAMS = [
  {
    name: 'Toddlers',
    age: '1 year',
    img: toddlers,
    alt: 'Toddler',
    color: 'var(--color-toddlers)',
    text: 'Our dynamic environment encourages joyful exploration, creative expression, and independent growth under the guidance of attentive teachers.',
  },
  {
    name: "Two's",
    age: '2 years',
    img: twos,
    alt: 'Two year old',
    color: 'var(--color-twos)',
    dark: true,
    text: 'Children engage in imaginative play, develop language skills, socialize, and explore their surroundings, all while preparing for the next stage of potty training.',
  },
  {
    name: "Three's",
    age: '3 years',
    img: threes,
    alt: 'Three year old',
    color: 'var(--pink-strong)',
    text: 'Children discover the joy of learning through cooperative play, themed exploration, and emergent literacy in our classroom where friendships flourish and curiosity thrives.',
  },
  {
    name: 'VPK',
    age: '4 years',
    img: vpk,
    alt: 'Pre-K child',
    color: 'var(--color-vpk)',
    text: 'Our well rounded and comprehensive VPK program incorporates the use of several enrichments classes and specialty techniques.',
  },
]

export default function Curriculum() {
  return (
    <section className="prog-section">
      <div className="prog-head">
        <span className="section-eyebrow">Classrooms</span>
        <h2 className="section-title">A place to grow at every age</h2>
      </div>

      <div className="prog-list">
        {PROGRAMS.map((p) => (
          <article className="prog-card" key={p.name} style={{ '--accent': p.color }}>
            <img src={p.img} alt={p.alt} />
            <span className={`prog-age ${p.dark ? 'dark' : ''}`}>{p.age}</span>
            <h3>{p.name}</h3>
            <p>{p.text}</p>
          </article>
        ))}
      </div>

      <Link to='/curriculum' className="btn btn-purple">View All Curriculums</Link>
      <Wave color="var(--purple-700)" />
    </section>
  )
}
